import { render, staticRenderFns } from "./PriceDetailInfoNewHome.vue?vue&type=template&id=115b89d2&scoped=true"
import script from "./PriceDetailInfoNewHome.vue?vue&type=script&lang=js"
export * from "./PriceDetailInfoNewHome.vue?vue&type=script&lang=js"
import style0 from "./PriceDetailInfoNewHome.vue?vue&type=style&index=0&id=115b89d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b89d2",
  null
  
)

export default component.exports